import React, { useLayoutEffect, useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import 'react-simple-keyboard/build/css/index.css';
import Styles from './orderItem.module.scss';
import cn from 'classnames';
import CustomKeyboard from '@components/common/CustomKeyboardCopy/indexRevamp';
import { LABEL } from '../../veriables';
import { flowType } from '../../utility/userInfo';
import { ReactComponent as Cross } from '@assets/images/cross.svg';
import { getObjectValue } from '@utility/utills';
import { TouchableButton, TouchableDiv } from '@components/common/Touchable/index';
import ModalHeader from '../../components/common/ModalHeader/index';

const BUTTON_THEME = {
  '{done}': {
    class: 'bgGreen',
  }
};

const createTable = React.memo(({
  type,
  maxLength,
  isAlpha,
  name,
  placeholder,
  onSubmit,
  isOpen,
  specialValue,
  cancelModal,
  isLandScape,
  browserOrtablet,
  setBrowserOrtablet,
  serverAppTheme,
  setOpenModal,
  seat,
  Item,
  ...props
}) => {
  const isServerApp = flowType() === 'serverApp';
  const isCallCenter = getObjectValue(() => isServerApp && [2].includes(props.deviceInfo.deviceGroup.startMode), false);
  const isKiosk = flowType() === 'kiosk';
  const [keyboardType, setKeyboardType] = useState(isKiosk ? 'kiosk' : 'textDefaultCaps');
  const [inputs, setInputs] = useState({
    [name]: specialValue
  });
  const [inputName, setInputName] = useState(name);
  const [isSwipedDown, setSwipedDown] = useState(true);

  // Ref for stable callback access — inputName rarely changes so ref is safe
  const inputNameRef = useRef(inputName);
  inputNameRef.current = inputName;

  const closeKeyboard = useCallback(() => {
    setSwipedDown(false);
  }, []);

  const onClickBtn = useCallback((e) => {
    const currentInputName = inputNameRef.current;
    setInputs(prev => {
      const newValue = e === '{bksp}'
        ? prev[currentInputName]?.slice(0, -1)
        : (prev[currentInputName] ? prev[currentInputName].concat(e) : ''.concat(e));
      return {
        ...prev,
        [currentInputName]: newValue,
      };
    });
  }, []);
  useLayoutEffect(() => {
    if (isAlpha) {
      setKeyboardType('numericAlpha');
    } else {
      setKeyboardType(type === 'number' ? 'numericDefault' : 'textDefaultCaps');
    }
  }, [type]);

  useLayoutEffect(() => {
    setInputs({
      ...inputs, [name]: specialValue
    });
  }, [isOpen]);

  const getInputValue = (inputNameDat) => {
    return (inputs[inputNameDat]) || '';
  };

  const keyboardCustomClass = useMemo(() => 'fs-30  p-2', []);

  const submit = () => {
    onSubmit(inputs[inputName]);
  };

  const handleBlur = () => {
    setSwipedDown(true);
    const element = document.querySelector(`#${name}`);
    element.blur();
  };

  useEffect(() => {
    if (window.ReactNativeWebView) {
      setBrowserOrtablet(false);
    } else {
      setBrowserOrtablet(true);
    }
  }, [])

  const tabletMode = (data) => {
    setInputName(data.name); setKeyboardType(data.type); handleBlur();
  }
  const browserMode = (data) => {
    setInputName(data.name); setKeyboardType(data.type); setSwipedDown(true);
  }

  const handleChange = (event) => {
    setInputs({
      ...inputs, [name]: event.target.value
    });

  }

  return (
    <>
      <div className=''>
        <ModalHeader
          isTab={seat?.tab}
          stationName={seat?.stationName}
          tileHeader={Item ? LABEL().ITEM_NOTE : LABEL().MODIFIER_ITEM_NOTE}
          seatNumber={seat?.number}
        />
      </div>
    <div className={cn('col-9', ' m-auto p-0 large-input row mx-0 justify-content-center')} style={{ color: serverAppTheme?.primary_text }}>
      <div className="fs_18 px-2 fw-600 col-12" style={{ color: serverAppTheme?.primary_text }}>
        {LABEL().SPECIAL_INSTRUCTIONS} &nbsp;
      </div>
      <div className="fs_18 px-2 py-1 fw-600 text-lowercase" style={{ color: serverAppTheme?.primary_text }}>
        ({20 - (getInputValue(name)?.length || 0)} of {20} remaining)
      </div>
      <div className={cn('p-0 my-2 position-relative', inputName === name && 'br-5 ',)}>
        <input
          id={name}
          type="text"
          name={name}
          className={cn('fw-500 pl-3 text-black', Styles.inputBorder)}
          style={{ width: '700px', height: isKiosk ? '5vh' : '8.6vh', fontSize: isKiosk ? '' : '20px', background: serverAppTheme?.inputBg, borderBottom: serverAppTheme?.inputBorder_Bottom, color: serverAppTheme?.primary_text, '--placeholder-color': serverAppTheme?.input_placeholder }}
          placeholder={placeholder}
          value={getInputValue(name)}
          maxLength="20"
          onFocus={() => { browserOrtablet ? browserMode({ name: name, type: 'textDefaultCaps' }) : tabletMode({ name: name, type: 'textDefaultCaps' }) }}
          onChange={(e) => browserOrtablet ? handleChange(e) : null}
        />
        {(name === 'specialInstructions' ? inputs?.specialInstructions !== '' : inputs?.specialInstruction !== '') && (
          <TouchableDiv
            role="presentation"
            className={cn('position-absolute fs-24')}
            style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}
            onClick={(e) => { e.preventDefault(); setInputs({}) }}
          >
            <Cross alt='cross' fill={serverAppTheme?.iconcolor} aria-hidden="true" />
          </TouchableDiv>
        )}
      </div>
      {(isSwipedDown && (browserOrtablet || !browserOrtablet)) && !isCallCenter && (
        <div style={{ bottom: '65px' }} className={cn(['numericAlpha'].includes(keyboardType) ? `w-50 ${Styles.keyboard}` : `w-100 ${Styles.keyboard1}`, !isSwipedDown && 'd-none', isSwipedDown ? isLandScape ? keyboardType === "text" ? "" : 'h-55' : keyboardType === 'numericAlpha' ? 'h-50' : '' : '')}>
          <CustomKeyboard
            setKeyboardType={setKeyboardType}
            onClickBtn={onClickBtn}
            type={isKiosk ? 'kiosk' : keyboardType}
            typed={inputs[inputName] || ''}
            closeKeyboard={closeKeyboard}
            btnSize={isKiosk ? 'btn35' : 'btn35'}
            customClass={keyboardCustomClass}
            maxLength={maxLength}
            buttonTheme={BUTTON_THEME}
            isOrderSeat={true}
          />
        </div>
      )}
      {isKiosk ? (
        <div className={cn('m-0 pt-2 w-100 row align-items-end justify-content-center')}>
          <div className="col-6 pl-0">
            <button
              className={cn('w-100 mt-2 btn100 od-btn-secondary')}
              type="submit"
              onClick={() => cancelModal(false)}
            >
              <div className="fs-30">{LABEL().KIOSK_CANCEL}</div>
            </button>
          </div>
          <div className="col-6 pr-0">
            <button
              className={cn('w-100 mt-2 btn100 btn-ripple')}
              type="submit"
              onClick={() => submit()}
            >
              <div className="fs-30">{LABEL().ADD_NOTE}</div>
            </button>
          </div>
        </div>) : (
        <div className={cn('col-12 d-flex align-items-center justify-content-center position-fixed bottom-0', Styles.buttonBottom)}>
          <div className='col-5 pr-1'>
            <TouchableButton type="button" className={cn('px-0 mb-2 mt-2 pl-2 rounded btn-ripple fs_24 fw-600 w-100 btn44')} onClick={(e) => { e.preventDefault(); setOpenModal(false); }} style={{ backgroundColor: serverAppTheme?.OFF_Premise_Btn, border: serverAppTheme?.cancleBtn_Border, color: serverAppTheme?.cancleBtn_font }} rippleEffect={true}>
              {LABEL().CANCEL}
            </TouchableButton>
          </div>
          <div className='col-5 pl-1'>
            <TouchableButton
              className={cn('w-100 btn44 btn-ripple')}
              type="button"
              onClick={(e) => { e.preventDefault(); submit() }}
              style={{ background: serverAppTheme?.secondaryBtn, color: serverAppTheme?.btn_font_color }}
              rippleEffect={true}
            >
              <div className="">{LABEL().SUBMIT}</div>
            </TouchableButton>
          </div>
        </div>)}
    </div>
    </>
  );
});

const mapStateToProps = ({ oauth }) => ({
  deviceInfo: oauth.deviceInformation,
});

export default connect(mapStateToProps)(createTable);
